import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';
import React, { useEffect, useRef, useState } from 'react';
import { Checkbox } from 'semantic-ui-react';
import SupaDropDown from './supaDropdown';
import PropTypes from 'prop-types';

const imageZoomDefaultValue = 1.2;
const minimumImageScale = 0.3;
const maximumImageScale = 3.0;
export default function TextInput(props) {
  const [imageEditable, setImageEditable] = useState(false);
  const [imageDropped, setImageDropped] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [value, setValue] = useState(props.value);
  const [currentImageScale, setCurrentImageScale] = useState(imageZoomDefaultValue);

  const inputChild = useRef(null);
  const domNode = useRef(null);

  useEffect(() => {
    if (props.timepicker) {
      window.$(domNode.current).calendar({ type: 'time', ampm: false });
    }

    if (props.datepicker) {
      window.$(domNode.current).calendar({
        type: 'date',
        monthFirst: false,
        onChange: props.onChange,
      });
    }

    if (props.focusme == 'true' && isVisible(domNode.current)) {
      let input = window.$(domNode.current).find('input').last();
      if (input.length == 0) {
        input = window.$(domNode.current).find('textarea').last();
      }
      window.$(input).focus();
    }
  }, []);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleClick = (option) => {
    props.onChange(option);
  };

  const handleUpload = () => {
    window.$(domNode.current).find('.drop-zone input').click();
  };

  const handleChange = (e) => {
    if (typeof e == 'object') props.onChange(e.target.value);
    else {
      // let input = window.$(domNode.current).find('input').last();
      props.onChange(e);
    }
  };

  const handleBlur = (e) => {
    if (props.onBlur) {
      if (typeof e == 'object') {
        props.onBlur(e.target.value);
      } else {
        // let input = window.$(domNode.current).find('input').last();
        props.onBlur(e);
      }
    }
  };

  const isHidden = (el) => {
    return el.offsetParent === null;
  };
  const isVisible = (el) => {
    return !isHidden(el);
  };

  const maskMe = () => {
    if (props.value == '') {
      setValue(props.mask);
    }
  };

  // not used anywhere
  // const getBase64 = () => {
  //   return this.refs[props.reference].getImageScaledToCanvas().toDataURL();
  // };

  const handleZoom = (evt) => {
    evt.preventDefault();
    if (evt.deltaY > 0) {
      //this means scroll down
      if (currentImageScale - 0.1 > minimumImageScale) setCurrentImageScale(currentImageScale - 0.1);
    } else {
      //this means scroll up
      if (currentImageScale + 0.1 < maximumImageScale) setCurrentImageScale(currentImageScale + 0.1);
    }
  };
  const onDrop = (files) => {
    if (files.length > 0) {
      setImageDropped(files[0].preview);
      setImageEditable(true);
    }
  };

  const numberOnKeyPress = (event) => {
    let intValue = parseInt(event.key);
    if (intValue >= 0 && intValue <= 9) {
      // do nothing if it is valid int
      return;
    }
    event.preventDefault();
  };

  const numberWithDecimalOnKeyPress = (event) => {
    if (event.key === '.') {
      // do nothing if it is decimal point
      return;
    } else {
      let intValue = parseInt(event.key);
      if (intValue >= 0 && intValue <= 9) {
        // do nothing if it is valid int
        return;
      }
      event.preventDefault();
    }
  };

  // let props = this.state;
  let elementToRender = <div />; //rendering empty is not supported as a top level element

  if (props.checkbox) {
    if (props.show != false) {
      elementToRender = (
        <Checkbox
          className={props.value ? props.classes + ' checked' : props.classes}
          onChange={handleChange}
          disabled={props.disabled}
          tabIndex={props.tabIndex}
          name={props.name || props.text}
          defaultChecked={props.checked || props.value}
          label={{
            children: props.text,
          }}
        />
      );
    }
  } else if (props.radio) {
    elementToRender = (
      <Checkbox
        radio
        label={{
          children: props.text,
        }}
        checked={props.checked}
        onChange={() => props.onChange()}
      />
    );
  } else if (props.image) {
    if (!props.reference) {
      console.error(
        'you must pass a ref through reference property, then do this.props.ref.NAME_OF_THIS_ELEMENT_PASSED_IN_REFERENCE_PROPERTY.getBase64() to get the base 64'
      );
    } else {
      let imageToDisplay = imageEditable ? (
        <AvatarEditor
          image={imageDropped || props.value}
          border={10}
          ref={props.reference}
          onDrop={onDrop}
          width={280}
          height={180}
          onMouseMove={() => {
            event.stopPropagation();
            event.preventDefault();
          }}
          onMouseUp={() => {
            event.stopPropagation();
            event.preventDefault();
          }}
          color={[255, 255, 255, 0.7]}
          scale={currentImageScale}
        />
      ) : (
        <img src={props.value} />
      );

      elementToRender = (
        <div>
          <Dropzone disableClick={true} onDrop={onDrop} className="drop-zone pointer" accept="image/*">
            <div className="canvas-holder" onWheel={handleZoom}>
              {imageToDisplay}
            </div>
            <div onClick={handleUpload || null} className="ui button color-button color-button-hover color-white ">
              {props.uploadButtonText}
            </div>
            {props.children}
          </Dropzone>
        </div>
      );
    }
  } else if (props.timepicker) {
    elementToRender = (
      <div
        ref={domNode}
        className={
          props.fieldClasses ? props.fieldClasses + ' field ui calendar time-based' : ' field ui calendar time-based'
        }
      >
        <div className="ui input left icon">
          <i className="time icon" />
          <input
            onKeyDown={props.onKeyDown || false}
            type="text"
            onChange={handleChange}
            value={props.value}
            placeholder={props.placeholder}
          />
          <label
            htmlFor={props.placeholder}
            className={
              props.labelClasses ? props.labelClasses + ' placeholder-label no-bold ' : ' placeholder-label no-bold '
            }
          >
            {props.placeholder}
          </label>
        </div>
      </div>
    );
  } else if (props.datepicker) {
    elementToRender = (
      <div
        ref={domNode}
        className={
          props.fieldClasses ? props.fieldClasses + ' field ui calendar date-based' : ' field ui calendar date-based'
        }
      >
        <div className="ui input left icon">
          <i className="date icon" />
          <input
            onKeyDown={props.onKeyDown || false}
            type="text"
            onChange={handleChange}
            value={props.value}
            placeholder={props.placeholder}
          />
          <label
            htmlFor={props.placeholder}
            className={
              props.labelClasses ? props.labelClasses + ' placeholder-label no-bold ' : ' placeholder-label no-bold '
            }
          >
            {props.placeholder}
          </label>
        </div>
      </div>
    );
  } else if (props.dropdown) {
    elementToRender = <SupaDropDown {...props} />;
  } else if (props.textArea) {
    elementToRender = (
      <div ref={domNode} className={props.fieldClasses + ' field no-gap'} data-show={props.show}>
        <textarea
          rows={props.rows || 4}
          onClick={props.mask != undefined ? maskMe : null}
          className={(props.classes || '') + (props.value ? ' filled' : '')}
          key={props.placeholder}
          placeholder={props.placeholder}
          value={props.value}
          autoComplete="off"
          id={props.id || null}
          tabIndex={props.tabIndex != undefined ? props.tabIndex : 0}
          onChange={handleChange}
          onScroll={props.onScroll}
        />
        {props.notRenderPlaceholderAsTitle ? (
          <label
            htmlFor={props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
            className={
              props.labelClasses ? props.labelClasses + ' placeholder-label no-bold ' : ' placeholder-label no-bold '
            }
          >
            {props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
          </label>
        ) : (
          ''
        )}
        <div className="clickEffect" />
        {props.children}
      </div>
    );
  } else if (props.arrowSlider) {
    elementToRender = (
      <div ref={domNode} className="arrow-slider-input">
        <div onClick={props.downArrowAction || null} className="right">
          <div className="slider-down">
            <i className="ui icon minus text-size-ml" />
          </div>
        </div>
        <div className="center">
          <input onClick={props.onClick || null} onChange={props.onChange} value={props.value} type="text" />
        </div>
        <div onClick={props.upArrowAction || null} className="left">
          <div className="slider-up">
            <i className="ui icon plus  text-size-ml" />
          </div>
        </div>
      </div>
    );
  } else if (props.number) {
    elementToRender = (
      <div
        ref={domNode}
        className={
          props.fieldClasses
            ? props.fieldClasses + ' field'
            : props.notRenderPlaceholderAsTitle
            ? ' field mrtxs'
            : ' field'
        }
        data-show={props.show}
      >
        <input
          ref={inputChild}
          maxLength={props.maxLength}
          autoComplete={props.autoComplete || 'false'}
          onClick={props.mask != undefined ? maskMe : null}
          onBlur={handleBlur}
          className={(props.classes || '') + (props.value ? ' filled' : '')}
          key={props.placeholder}
          type="number"
          onKeyPress={props.allowDecimal ? numberWithDecimalOnKeyPress : numberOnKeyPress}
          placeholder={props.placeholder}
          value={value}
          id={props.id || null}
          tabIndex={props.tabIndex != undefined ? props.tabIndex : 0}
          onChange={handleChange}
          name={props.name}
          disabled={props.disabled}
        />
        {props.notRenderPlaceholderAsTitle ? (
          ''
        ) : (
          <label
            htmlFor={props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
            className={props.labelClasses + ' placeholder-label no-bold '}
          >
            {props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
          </label>
        )}
        <div className="clickEffect" />
        {props.children}
      </div>
    );
  } else if (props.labelRelativeRenderOnTop) {
    // When input label is long, it should be position relative and render on the top
    elementToRender = (
      <div ref={domNode}>
        <div
          htmlFor={props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
          className={props.labelClasses + ' placeholder-label no-bold div-like color-placeholder'}
          style={{
            opacity: props.value || isFocused ? '1' : '0',
          }}
        >
          {props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
        </div>
        <div
          className={
            props.notRenderPlaceholderAsTitle ? props.fieldClasses + ' field no-gap' : props.fieldClasses + ' field'
          }
        >
          <input
            ref={inputChild}
            maxLength={props.maxLength}
            autoComplete={props.autoComplete || 'false'}
            onClick={props.mask != undefined ? maskMe : null}
            onBlur={(e) => {
              handleBlur(e);
              setIsFocused(false);
            }}
            onFocus={(e) => setIsFocused(true)}
            className={(props.classes || '') + (props.value ? ' filled' : '')}
            key={props.placeholder}
            type={props.type || 'text'}
            pattern={props.pattern}
            onKeyPress={props.onKeyPress}
            placeholder={props.placeholder}
            value={value}
            id={props.id || null}
            tabIndex={props.tabIndex != undefined ? props.tabIndex : 0}
            onChange={props.customOnChange ? props.onChange : handleChange}
            name={props.name}
            disabled={props.disabled}
          />
          {props.children}
        </div>
      </div>
    );
  } else if (props.textareaLabelRelativeRenderOnTop) {
    // When input label is long, it should be position relative and render on the top
    elementToRender = (
      <div ref={domNode}>
        <div
          htmlFor={props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
          className={props.labelClasses + ' placeholder-label no-bold div-like color-placeholder'}
          style={{
            opacity: props.value || isFocused ? '1' : '0',
          }}
        >
          {props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
        </div>
        <div
          className={
            props.notRenderPlaceholderAsTitle ? props.fieldClasses + ' field no-gap' : props.fieldClasses + ' field'
          }
        >
          <textarea
            rows={props.rows || 4}
            onClick={props.mask != undefined ? maskMe : null}
            onBlur={(e) => {
              handleBlur(e);
              setIsFocused(false);
            }}
            style={props.style}
            onFocus={(e) => setIsFocused(true)}
            className={(props.classes || '') + (props.value ? ' filled' : '')}
            key={props.placeholder}
            placeholder={props.placeholder}
            value={props.value}
            name={props.name}
            autoComplete="off"
            id={props.id || null}
            tabIndex={props.tabIndex != undefined ? props.tabIndex : 0}
            onChange={handleChange}
          />
          {props.children}
        </div>
      </div>
    );
  } else {
    //inputs like passwords and normal fields
    elementToRender = (
      <div
        ref={domNode}
        className={
          props.notRenderPlaceholderAsTitle ? props.fieldClasses + ' field no-gap' : props.fieldClasses + ' field'
        }
        data-show={props.show}
      >
        <input
          ref={inputChild}
          maxLength={props.maxLength}
          autoComplete={props.autoComplete || 'false'}
          onClick={props.mask != undefined ? maskMe : null}
          onBlur={props.customOnBlur ? props.onBlur : handleBlur}
          className={(props.classes || '') + (props.value ? ' filled' : '')}
          key={props.placeholder}
          type={props.type || 'text'}
          pattern={props.pattern}
          onKeyPress={props.onKeyPress}
          placeholder={props.placeholder}
          value={props.value}
          id={props.id || null}
          tabIndex={props.tabIndex != undefined ? props.tabIndex : 0}
          onChange={props.customOnChange ? props.onChange : handleChange}
          name={props.name}
          disabled={props.disabled}
          onFocus={props.onFocus}
          readOnly={props.readOnly}
        />
        {props.notRenderPlaceholderAsTitle ? (
          ''
        ) : (
          <label
            htmlFor={props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
            className={props.labelClasses + ' placeholder-label no-bold '}
          >
            {props.titlePlaceholder ? props.titlePlaceholder : props.placeholder}
          </label>
        )}
        <div className="clickEffect" />
        {props.children}
      </div>
    );
  }

  return elementToRender;
}

TextInput.propTypes = {
  name: PropTypes.string, // name property on text box
  autoComplete: PropTypes.string,
  maxLength: PropTypes.number, //max length optional property for the text field
  allowDecimal: PropTypes.bool, // setting true means txt number allows entering both decimal point and digits
};
